'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const WorkOrderTrendChart = dynamic(
  () => import('./charts/WorkOrderTrendChart'),
  { ssr: false, loading: () => <div className="skeleton-shimmer rounded-xl h-72 w-full" /> }
);

const OrdersByBuildingChart = dynamic(
  () => import('./charts/OrdersByBuildingChart'),
  { ssr: false, loading: () => <div className="skeleton-shimmer rounded-xl h-72 w-full" /> }
);

const OrderTypeChart = dynamic(
  () => import('./charts/OrderTypeChart'),
  { ssr: false, loading: () => <div className="skeleton-shimmer rounded-xl h-72 w-full" /> }
);

export default function DashboardChartsRow() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4">
      {/* Trend chart — spans 2 cols */}
      <div className="lg:col-span-2 bg-card border border-border rounded-xl shadow-card p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-sm font-600 text-foreground">Ordens Abertas vs Concluídas</h3>
            <p className="text-xs text-muted-foreground mt-0.5">Últimos 30 dias</p>
          </div>
          <div className="flex items-center gap-4 text-xs">
            <span className="flex items-center gap-1.5">
              <span className="w-2.5 h-2.5 rounded-full bg-blue-500 inline-block" />
              <span className="text-muted-foreground">Abertas</span>
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-2.5 h-2.5 rounded-full bg-emerald-500 inline-block" />
              <span className="text-muted-foreground">Concluídas</span>
            </span>
          </div>
        </div>
        <WorkOrderTrendChart />
      </div>

      {/* Type distribution */}
      <div className="bg-card border border-border rounded-xl shadow-card p-5">
        <div className="mb-4">
          <h3 className="text-sm font-600 text-foreground">Distribuição por Tipo</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Mês atual</p>
        </div>
        <OrderTypeChart />
      </div>

      {/* By building — full width */}
      <div className="lg:col-span-3 bg-card border border-border rounded-xl shadow-card p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-sm font-600 text-foreground">Ordens por Prédio</h3>
            <p className="text-xs text-muted-foreground mt-0.5">Top 6 prédios — set/2026</p>
          </div>
        </div>
        <OrdersByBuildingChart />
      </div>
    </div>
  );
}